import React, { useState } from 'react';
import { Button, Dropdown, Spinner } from 'react-bootstrap';
import { FaDownload, FaFileExcel, FaSpinner } from 'react-icons/fa';
import { toast } from 'react-toastify';

const ExportButton = ({ 
  onExport, 
  disabled = false,
  variant = 'success',
  size = 'md',
  label = 'Export',
  icon = <FaDownload className="me-2" />
}) => {
  const [exporting, setExporting] = useState(false);

  const handleExport = async () => {
    try {
      setExporting(true);
      await onExport();
      toast.success('Export completed! File downloaded.');
    } catch (error) {
      console.error('Export failed:', error);
      toast.error(error.response?.data?.message || 'Export failed. Please try again.');
    } finally {
      setExporting(false);
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleExport}
      disabled={disabled || exporting}
    >
      {exporting ? (
        <Spinner animation="border" size="sm" className="me-2" />
      ) : (
        icon
      )}
      {exporting ? 'Exporting...' : label}
    </Button>
  );
};

export default ExportButton;